export default {
    SET_ENROLLMENTS_BEGIN: 'SET_ENROLLMENTS_BEGIN',
    SET_ENROLLMENTS_SUCCESS: 'SET_ENROLLMENTS_SUCCESS',
    SET_ENROLLMENTS_ERROR: 'SET_ENROLLMENTS_ERROR',
    SET_ENROLLMENTS_CLEANUP: 'SET_ENROLLMENTS_CLEANUP',
    UPDATE_DEMOGRAPHIC_FIELD: 'UPDATE_DEMOGRAPHIC_FIELD',
    SET_DEFAULT_DEMOGRAPHIC_FIELD: 'SET_DEFAULT_DEMOGRAPHIC_FIELD'
  };
  